import ShipmentIndexPage from "./ShipmentIndexPage";
export default ShipmentIndexPage;
